import { useEffect, useState } from "react";

import { Box, Button } from "@mui/material";
import api from "../../api";

function LibraryActions({
    junctionTable = 'recipe_retailer',
    junctionPayload,
    inLibraryStatus,
    onLibraryStatusChange = () => {},
}) {
    const [inLibrary, setInLibrary] = useState(null);
    const [loading, setLoading] = useState(false);

    const checkIfInLibrary = async () => {
        const payload = {
            filter: {
                _and: [junctionPayload]
            }
        };

        const junctionTableItems = await api.getJunctionItems(junctionTable, payload);
        return junctionTableItems?.length > 0;
    }

    const addToLibrary = async () => {
        try {
            setLoading(true);

            await api.addToJunction(junctionTable, junctionPayload);

            setInLibrary(true);
            onLibraryStatusChange(true);
        } catch (error) {
            console.log('error: ', error);
        } finally {
            setLoading(false);
        }
    }

    const removeFromLibrary = async () => {
        try {
            setLoading(true);

            // get key of junctions items to remove
            const fetchJunctionItemsPayload = {
                filter: {
                    _and: [junctionPayload]
                }
            };
            const junctionItems = await api.getJunctionItems(junctionTable, fetchJunctionItemsPayload);

            // delete junctions items
            const payload = {
                keys: junctionItems.map(item => item.id),
            };

            await api.deleteFromJunction(junctionTable, payload);

            setInLibrary(false);
            onLibraryStatusChange(false);
        } catch (error) {
            console.log('error: ', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (typeof inLibraryStatus === "boolean") {
            setInLibrary(inLibraryStatus);
        }
    }, [inLibraryStatus]);

    useEffect(() => {
        if (typeof inLibraryStatus === "boolean") {
            return;
        }

        const initialise = async () => {
            setInLibrary(await checkIfInLibrary());
        };

        initialise();
    }, []);
    
    return (
        <Box>
            {
                inLibrary === false &&
                <>
                    <Button
                        disabled={loading}
                        onClick={() => { addToLibrary() }}
                        variant="outlined"
                        sx={{
                            color: '#000',
                            background: '#efeeee',
                            borderColor: '#e0e0e0',
                            width: '100%',
                            fontSize: `0.75rem`,
                            fontWeight: 'bold'
                        }}
                    >
                        Add to Library
                    </Button>
                </>
            }

            {
                inLibrary === true &&
                <>
                    <Button
                        disabled={loading}
                        onClick={() => { removeFromLibrary() }}
                        variant="outlined"
                        sx={{
                            color: '#000',
                            background: '#efeeee',
                            borderColor: '#e0e0e0',
                            width: '100%',
                            fontSize: `0.75rem`,
                            fontWeight: 'bold'
                        }}
                    >
                        Remove from Library
                    </Button>
                </>
            }
        </Box>
    )
}

export default LibraryActions